
import React,{ useEffect, useState } from "react";
import { useParams, Link } from 'react-router-dom';
import axios from 'axios'
import clsx from 'clsx'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import SidebarMenuItem from "./SidebarMenuItem";
import SidebarMenuItemWithSub from "./SidebarMenuItemWithSub"
import { storeMenu } from "../../../../../app/redux/storeMenuUrl";
import SAISVG from "../../../../helpers/CommonFunction";

const SidebarMenuMain = () => {
    const { company } = useParams();
    const dispatch = useDispatch();

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    
    const [ allMenuList, setAllMenuList ] = useState([]);

    const getMenuList = async () => {
        const apiHeaders = {
            headers: {
                "x-access-token": localStorage.getItem('systemAdminToken'),
            },
        };
        let reqObj = {
            sass_id : localStorage.getItem('sass_id'),
            user_type : localStorage.getItem('type')
        };
        try {
            await axios.post(`${api_base_url}admin/get-assign-menu-list`, reqObj, apiHeaders)
            .then(async (res) => {
                if(res.data.status === 'success'){
                    if(res.data.data.menu_list.length > 0){
                        setAllMenuList(res.data.data.menu_list)
                    }
                }
                else{
                    toast.error("There is an error");
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error) {
            console.error("Error during save:", error);
        }
    }
    useEffect(() => {
        getMenuList();
    },[]);

    const [menuHtml, setMenuHtml] = useState(null);
    const [allAssignMenu, setAllAssignMenu] = useState({ menu_urls: [] });
    useEffect(() => {
        if (allMenuList.length > 0) {
            let updatedMenu = [];
            // updatedMenu.push({ menu_url: 'settings/business-setup' });
            const generatedMenuHtml = allMenuList.map((allMenu) => {
                let submenuItems = [];
                if (allMenu.submenu_list && allMenu.submenu_list.length > 0) {
                    submenuItems = allMenu.submenu_list.map((submenu) => {
                        updatedMenu.push({ menu_url: submenu.menu_url });
                        return (
                            <SidebarMenuItem 
                                key={uuidv4()}
                                to={company +'/'+ submenu.menu_url}
                                title={submenu.menu_name}
                                hasBullet={false}
                            />
                        );
                    });
                    return (
                        <SidebarMenuItemWithSub
                            key={uuidv4()}
                            to={company +'/'+ allMenu.menu_name.toLowerCase()}
                            title={allMenu.menu_name}
                            icon={allMenu.menu_icon}
                        >
                            {submenuItems}
                        </SidebarMenuItemWithSub>
                    );
                } else {
                    if(allMenu.menu_url === 'agents'){
                        updatedMenu.push({ menu_url: 'manage-virtual-agent' });
                    }
                    updatedMenu.push({ menu_url: allMenu.menu_url });
                    return (
                        <SidebarMenuItem
                            key={uuidv4()}
                            to={company+'/'+allMenu.menu_url}
                            icon={allMenu.menu_icon}
                            title={allMenu.menu_name}
                        />
                    );
                }
            });
            setMenuHtml(generatedMenuHtml);
            setAllAssignMenu((prevData) => ({
                ...prevData,
                menu_urls: updatedMenu,
            }));
        }
    }, [allMenuList]);

    useEffect(() => {
        if(allAssignMenu.menu_urls.length > 0){
            dispatch(storeMenu(allAssignMenu.menu_urls))
        }
    },[allAssignMenu])

    return (
        <>
            {menuHtml}
            {/* <SidebarMenuItem
                to={`${company}/agent`}
                icon='media/icons/duotune/technology/teh003.svg'
                title="Agents"
                fontIcon='bi-app-indicator'
            />
            <SidebarMenuItemWithSub
                to={`${company}/report`}
                title='Report'
                icon='media/icons/duotune/general/gen005.svg'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to={`${company}/report/cdr-report`} title='CDR Report' hasBullet={false} />
                <SidebarMenuItem to={`${company}/report/missed-chat`} title='Missed Chat' hasBullet={false} />
            </SidebarMenuItemWithSub> */}

       
            <SidebarMenuItem
                to={`dashboard`}
                icon='media/icons/duotune/finance/fin006.svg'
                title="Biz List"
                fontIcon='bi-app-indicator'
            />
        </>
    )
}

export default SidebarMenuMain;